import { Button, Divider, Flex, Typography } from 'antd'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import BasicInfo from '../../Components/BasicInfo/BasicInfo'
import BasicInfoForm from '../../Components/BasicInfoForm/BasicInfoForm'
import CharacterLimitedTextArea from '../../Components/CharacterLimitedTextArea/CharacterLimitedTextArea'
import ProfileInfo from '../../Components/ProfileInfo/ProfileInfo'
import RestaurantInfoName from '../../Components/RestaurantInfo/RestaurantInfoName'
import { isMobile } from 'react-device-detect'

export default function NewRestaurantProfilePage() {
    const restaurant = JSON.parse(localStorage.getItem("userData"));
    const [description, setDescription] = useState(restaurant.description);
    const dispatch = useDispatch();
    return (
        <Flex vertical >
            <Typography.Title level={2} style={{
                margin: "auto",
                paddingTop: "1rem",
                paddingBottom: "1rem",
            }}>
                Perfil do Restaurante

            </Typography.Title>
            {isMobile === true ? (<Flex align='center' vertical justify='center' style={{
                maxWidth: "100vw",
                gap: "20px",
            }}>
                <Flex align='center' justify='center' style={{
                    margin: "auto",
                    width: "95vw",
                    minWidth: "95vw",
                    maxWidth: "95vw",
                    alignSelf: "center",
                    justifySelf: "center",
                    borderRadius: "12px",
                    boxShadow: "1px 2px 9px rgba(0, 0, 0, 0.245)",
                    backgroundColor: "white",
                }} >
                    <BasicInfo />
                </Flex>
                <Flex align='center' justify='center' style={{
                    margin: "auto",
                    width: "95vw",
                    minWidth: "95vw",
                    maxWidth: "95vw",
                    alignSelf: "center",
                    justifySelf: "center",
                    borderRadius: "12px",
                    boxShadow: "1px 2px 9px rgba(0, 0, 0, 0.245)",
                    backgroundColor: "white",
                }} >
                    <BasicInfoForm />
                </Flex>
            </Flex>
            ) : (<Flex align='center' justify='space-evenly' style={{
                maxWidth: "90vw",
            }}>
                <Flex align='center' justify='center' style={{
                    width: "42vw",
                    minWidth: "42vw",
                    maxWidth: "42vw",
                    height: "90vh",
                    alignSelf: "center",
                    justifySelf: "center",
                    padding: "1rem",
                    borderRadius: "12px",
                    boxShadow: "1px 2px 9px rgba(0, 0, 0, 0.245)",
                    backgroundColor: "white",
                }} >
                    <BasicInfo />
                </Flex>
                <Flex align='center' justify='center' style={{
                    width: "42vw",
                    minWidth: "42vw",
                    maxWidth: "42vw",
                    height: "90vh",
                    alignSelf: "center",
                    justifySelf: "center",
                    padding: "1rem",
                    borderRadius: "12px",
                    boxShadow: "1px 2px 9px rgba(0, 0, 0, 0.245)",
                    backgroundColor: "white",
                }} >
                    <BasicInfoForm />
                </Flex>
            </Flex>
            )}
        </Flex >
    )
}
